import { create } from 'zustand';

interface DspWarehouse {
  id: string;
  name: string;
}

interface DspWarehouseState {
  warehouses: DspWarehouse[];
  selectedWarehouseId: string | null;
  setWarehouses: (warehouses: DspWarehouse[]) => void;
  setSelectedWarehouseId: (id: string) => void;
}

const useDspWarehouseStore = create<DspWarehouseState>((set) => ({
  warehouses: [],
  selectedWarehouseId: null,
  setWarehouses: (warehouses) => set((state) => {
    const newState: Partial<DspWarehouseState> = { warehouses };
    if (state.selectedWarehouseId === null && warehouses.length > 0) {
      newState.selectedWarehouseId = warehouses[0].id;
    }
    return newState;
  }),
  setSelectedWarehouseId: (id) => set({ selectedWarehouseId: id }),
}));

export default useDspWarehouseStore;
